// Weeks start on Monday, India time, as on the server (private.week_start).

const IST_MS = 5.5 * 60 * 60 * 1000;

/** The Monday this week starts on, India time, as YYYY-MM-DD. */
export function weekStart(now: Date = new Date()): string {
  const ist = new Date(now.getTime() + IST_MS);
  ist.setUTCDate(ist.getUTCDate() - ((ist.getUTCDay() + 6) % 7));
  return ist.toISOString().slice(0, 10);
}

export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}
